const mapMarkers = document.querySelectorAll('.mapMarker');
const officeBlocks = document.querySelectorAll('.officeBlock');

if (mapMarkers) {

    mapMarkers.forEach( (item) => {
        item.addEventListener('click', () => {

            // reset office blocks
            officeBlocks.forEach( (item) => {
                item.classList.remove('is-active');
            })

            //reset map markers
            mapMarkers.forEach( (item) => {
                item.classList.remove('is-active');
            })

            // get offices
            let officeData = item.dataset.office;
            officeData = officeData.split(';');

            // add active class to chosen marker
            item.classList.toggle('is-active');

            // add active class to office blocks
            officeData.forEach( (item) => {
                document.getElementById(item).classList.add('is-active');
            });
        })
    })
}